import { AbstractControl, ValidationErrors } from '@angular/forms';

const EMAIL_REGEXP = /^[\p{L}0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/u;

function isEmptyInputValue(value: any): boolean {
  // we don't check for string here so it also works with arrays
  return value == null || value.length === 0;
}

export class UserValidators {
  static email(control: AbstractControl): ValidationErrors | null {
    return UserValidators.emailValidator(control, 'email');
  }

  static emailWithCustomError(errorName: string): (control: AbstractControl) => ValidationErrors | null {
    return (control: AbstractControl) => UserValidators.emailValidator(control, errorName);
  }

  private static emailValidator(control: AbstractControl, errorName: string = 'email'): ValidationErrors | null {
    if (isEmptyInputValue(control.value)) {
      return null; // don't validate empty values to allow optional controls
    }

    if (EMAIL_REGEXP.test(control.value)) {
      return null; // validation ok
    }

    const error = {};
    error[errorName] = true;
    return error;
  }

  static matchPassword(control: AbstractControl): ValidationErrors | null {
    const confirmPasswordErrors = (control.get('confirmPassword') as AbstractControl).errors;
    if (
      !control.get('password') ||
      !control.get('confirmPassword') ||
      (!!confirmPasswordErrors && !confirmPasswordErrors['matchPassword'])
    ) {
      return null;
    }

    (control.get('confirmPassword') as AbstractControl).setErrors(null);

    const password = (control.get('password') as AbstractControl).value; // to get value in input tag
    const confirmPassword = (control.get('confirmPassword') as AbstractControl).value; // to get value in input tag
    if (password !== confirmPassword) {
      (control.get('confirmPassword') as AbstractControl).setErrors({ matchPassword: true });
      return { matchPassword: true };
    }
    return null;
  }
}
